/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import * as $ from 'jquery';
import { Observable } from 'rxjs/Rx';
import { NgProgress } from 'ngx-progressbar';
import { Component, OnInit } from '@angular/core';
import { MOloop } from './../../../pipes/mo-loop.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CategoriesService } from '../../../services/Home/categories.service';

@Component({
  selector: 'martmax-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css'],
  providers: [CategoriesService],
})

export class CategoriesComponent implements OnInit {

  config: any = {
    pagination: '.swiper-pagination',
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    paginationClickable: true,
    spaceBetween: 0,
    autoplay: 1500,
    loop: true,
  };

  errors: any;
  coupon: any;
  mainBannersA: any;
  mainBannersB: any;
  mainBannersC: any;
  mainBannersD: any;
  searchForm: FormGroup;
  mainBannersSlider: any;
  megaMenuHorizontal: any;
  defaultImage: string = "./assets/images/martmax-lazyload.jpg";

  /**
 * timer
 */

  public diff: number;
  public days: number;
  public hours: number;
  public minutes: number;
  public seconds: number;
  public trialEndsAt: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public progress: NgProgress,
    public route: ActivatedRoute,
    public categoriesService: CategoriesService,
  ) {
  }

  public ngOnInit() {

    this.loadMainBanners();

    this.createBuyForMeForm();

    this.couponTimer();

  }

  /**
   * create buy for me form
   */
  public createBuyForMeForm() {
    this.searchForm = this.fb.group({
      url: ['', [Validators.required]]
    });
  }

  /**
 * submit keywords
 */
  public submitKeywords() {
    this.progress.start();
    let url = this.validateURL(this.searchForm.value.url);
    if (url) {
      return this.router.navigate(['products/buyforme']);
    }
    this.progress.done();
  }

  /**
 * validate url 
 * 
 * @param url 
 */
  public validateURL(url: string) {
    let pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    if (pattern.test(url)) {
      return true;
    }
  }

  public copyToClipboard() {
    $('#btn').click(function () {
      $(this).addClass('clicked');
      $(this).html('saved <i class="fa fa-check-square-o" aria-hidden="true"></i>');
    });
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($('#code').text()).select();
    document.execCommand("copy");
    $temp.remove();
  }

  /**
   * timer
   */
  public couponTimer() {
    Observable.interval(1000).map((x) => {
      this.diff = Date.parse(this.trialEndsAt) - Date.parse(new Date().toString());
    }).subscribe((x) => {
      this.days = this.getDays(this.diff);
      this.hours = this.getHours(this.diff);
      this.minutes = this.getMinutes(this.diff);
      this.seconds = this.getSeconds(this.diff);
    });
  }

  getDays(t) {
    return Math.floor(t / (1000 * 60 * 60 * 24));
  }

  getHours(t) {
    return Math.floor((t / (1000 * 60 * 60)) % 24);
  }

  getMinutes(t) {
    return Math.floor((t / 1000 / 60) % 60);
  }

  getSeconds(t) {
    return Math.floor((t / 1000) % 60);
  }

  /**
   * load main banners
   */
  public loadMainBanners() {
    this.categoriesService.getCategories().subscribe(
      (data) => {
        this.coupon = data.coupon;
        this.trialEndsAt = data.coupon.end_date;
        this.mainBannersA = data.mainBanners.A;
        this.mainBannersB = data.mainBanners.B;
        this.mainBannersC = data.mainBanners.C;
        this.mainBannersD = data.mainBanners.D;
        this.mainBannersSlider = data.mainBanners.Slider;
        this.megaMenuHorizontal = data.megaMenuHorizontal;
      },
      (errors) => {
        this.errors = errors;
      }
    );
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/categories/categories.component.ts